import ExcelJS from "exceljs";
import {GenerateExportExcelHeadColumnStylesCb, GenerateExportExcelRowStylesCb} from "@ui/tableCustom/types/table";
import {calcDataSetRowsIndex} from "./buildData/helpers/calcDataSetRowsIndex";
import {IExportDataSetItem} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {saveExcelFile} from "./saveExcelFile/saveExcelFile";
import {buildExcelData} from "./buildData/buildExcelData";
import {IExcelBaseSettings} from "@containers/export/containers/excel/types";


export async function generateExcelJS<T>({
                                             dataSet,
                                             generateExportExcelRowStylesCb,
                                             generateExportExcelHeadColumnStylesCb,
                                             fileName,
                                             baseSettings,
                                         }: {
    dataSet: IExportDataSetItem[],
    fileName: string,
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb,
    baseSettings?: IExcelBaseSettings

}) {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
        pageSetup: baseSettings?.pageSetup
    });

    let globalDataSetRowIndex = 0;
    dataSet.forEach((excelData) => {
        buildExcelData<T>({
            worksheet,
            excelData,
            generateExportExcelRowStylesCb,
            generateExportExcelHeadColumnStylesCb,
            dataSetRowIndex: globalDataSetRowIndex,
        })
        globalDataSetRowIndex += calcDataSetRowsIndex(excelData)
    })

    saveExcelFile(workbook, fileName)
}

